import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { DBRecurringImport } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit' | 'page'>;

type Response = DBRecurringImport[];

/**
 * List scheduled (recurring) imports for the imports-tab recurring drawer.
 * No default page size: the backend's own default applies unless the caller
 * opts into an explicit limit/page.
 */
export const getRecurringImports = async (
  scope: RequestScope,
  { limit, page }: RequestParams = {},
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>('/recurring_import', {
      ...requestOptions,
      params: {
        sort: 'created_at:-1',
        ...(limit !== undefined ? { limit } : {}),
        ...(page !== undefined ? { page } : {}),
      },
    });

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
